/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ENSToken, ENSTokenInterface } from "../ENSToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "freeSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "airdropSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_claimPeriodEnds",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "claimant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromDelegate",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toDelegate",
        type: "address",
      },
    ],
    name: "DelegateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "previousBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBalance",
        type: "uint256",
      },
    ],
    name: "DelegateVotesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "merkleRoot",
        type: "bytes32",
      },
    ],
    name: "MerkleRootChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "pos",
        type: "uint32",
      },
    ],
    name: "checkpoints",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "fromBlock",
            type: "uint32",
          },
          {
            internalType: "uint224",
            name: "votes",
            type: "uint224",
          },
        ],
        internalType: "struct ERC20Votes.Checkpoint",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimPeriodEnds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "delegate",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "claimTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
    ],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "delegates",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "isClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "merkleRoot",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumMintInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintCap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "numCheckpoints",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address",
      },
    ],
    name: "sweep",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ENSToken__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    freeSupply: BigNumberish,
    airdropSupply: BigNumberish,
    _claimPeriodEnds: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ENSToken> {
    return super.deploy(
      freeSupply,
      airdropSupply,
      _claimPeriodEnds,
      overrides || {}
    ) as Promise<ENSToken>;
  }
  getDeployTransaction(
    freeSupply: BigNumberish,
    airdropSupply: BigNumberish,
    _claimPeriodEnds: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      freeSupply,
      airdropSupply,
      _claimPeriodEnds,
      overrides || {}
    );
  }
  attach(address: string): ENSToken {
    return super.attach(address) as ENSToken;
  }
  connect(signer: Signer): ENSToken__factory {
    return super.connect(signer) as ENSToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ENSTokenInterface {
    return new utils.Interface(_abi) as ENSTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ENSToken {
    return new Contract(address, _abi, signerOrProvider) as ENSToken;
  }
}
